import { createSelector } from 'reselect';
import { standortStateSelector } from '../standort';
import { datECodePrefixSelector } from '../vehicle';

const vehicleFilterStateByDatECodeSelector = createSelector([standortStateSelector], standortState => standortState.vehicleFilter);

export const vehicleFilterStateSelector = createSelector(
    [vehicleFilterStateByDatECodeSelector, datECodePrefixSelector],
    (vehicleFilterStateByDatECode, datECodePrefix) => vehicleFilterStateByDatECode?.[datECodePrefix] ?? {}
);
